/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/flux/entity'


export default class extends Entity
{
  constructor()
  {
    super([]);
  }


  link (target)
  {
    if (this.target)
    {
      throw new Error('Cannot link alias twice.');
    }

    this.target = target;
  }


  getDefaultEntity ()
  {
    if (!this.target)
    {
      throw new Error('Cannot use alias without linking it first');
    }

    return this.target.getDefaultEntity();
  }


};
